<template>
	<v-form
			class="h-email-form"
			:action="action"
			enctype="multipart/form-data"
			ref="form"
			v-model="valid"
			lazy-validation
			method="post"
	>
		<h2 v-if="caption" class="h-email-caption">{{ caption }}</h2>
		<v-text-field
				name="full_name"
				v-model="full_name"
				:rules="full_name_rules"
				label="Your Full Name"
				required
				:box="!is_mobile"
				:outline="is_mobile"
				class="h-contact-us-input required"
				flat
				v-if="fullNameRequired"
				:background-color="input_background_color"
		></v-text-field>
		<v-text-field
				name="email_from"
				v-model="email_from"
				:rules="email_rules"
				label="Your email"
				required
				:box="!is_mobile"
				:outline="is_mobile"
				class="h-contact-us-input required"
				flat
				v-if="emailRequired"
				:background-color="input_background_color"
		></v-text-field>
    <v-textarea
        v-if="!editSubject"
        v-model="subj"
        label="Subject"
        required
        :readonly="true"
        :disabled="true"
        :outline="is_mobile"
        :box="!is_mobile"
        :auto-grow="true"
        :rows="1"
        class="h-email-form-subject h-contact-us-input required"
    ></v-textarea>
		<v-text-field
        v-if="editSubject"
				v-model="subj"
				:counter="editSubject ? 80 : null"
				:rules="subject_rules"
				label="Subject"
				required
				:readonly="!editSubject"
				:disabled="!editSubject"
				:outline="is_mobile"
				:box="!is_mobile"
				class="h-contact-us-input required"
				flat
				:background-color="is_mobile ? '' : editSubject ? '#fff' : '#eee'"
		></v-text-field>


		<input type="hidden" name="email_subject" :value="subj">
		<input type="hidden" name="return_success_url" :value="onSuccessUrl">
		<input type="hidden" name="return_error_url" :value="onErrorUrl">
		<input type="hidden" name="destination_key" :value="destinationKey">

		<input type="hidden" :name="n" :value="v" v-if="payload" v-for="(v, n) in payload">

		<v-textarea
				name="email_content"
				v-model="content"
				:rules="content_rules"
				required
				:disabled="!editBody"
				label="Message"
				:rows="rows"
				:outline="is_mobile"
				:box="!is_mobile"
				flat
				:background-color="input_background_color"
				class="h-email-form-body h-contact-us-input required"
		></v-textarea>

		<div>
			<div>
				<v-btn @click="$refs.attachmentFile.click()">
					<v-icon>attach_file</v-icon>
					{{ attachment ? attachment : 'Attach Screenshot' }}
				</v-btn>
				<input type="hidden" name="MAX_FILE_SIZE" value="10485760">
				<input type="file" style="display: none" name="attachment" ref="attachmentFile" accept="image/*,image/jpeg,image/png" @change="onAttach">
				<span class="h-attach-error error--text" v-if="attachment_error != null">{{ attachment_error }}</span>
				<span class="button-info" v-if="attachment_error == null"><sup>*</sup>PNG or JPG file up to 10Mb</span>
			</div>

			<div class="mt-3">
				<v-btn
						@click="send"
						color="info"
						large
						round
						dark
				>
					Send
				</v-btn>
			</div>
		</div>
	</v-form>
</template>

<script>
	export default {
		name: "EmailForm",

		props: {
			destinationKey: {
				type: String,
				default: 'cs'
			},
			action: {
				type: String,
				default: '/service/customer_help/tools/mail.php'
			},
			caption: {
				type: String,
				default: null
			},
			subject: {
				type: String,
				default: ""
			},
			editSubject: {
				type: Boolean,
				default: false
			},
			body: {
				type: String,
				default: ""
			},
			editBody: {
				type: Boolean,
				default: false
			},
			onSuccessUrl: {
				type: String,
				default: ""
			},
			onErrorUrl: {
				type: String,
				default: ""
			},
			ajax: {
				type: Boolean,
				default: false
			},
            emailRequired: {
                type: Boolean,
                default: false
            },
			fullNameRequired: {
                type: Boolean,
                default: false
            },
			mustEdit: {
				type: Boolean,
				default: false
			},
			attachScreenshot: {
				type: Boolean,
				default: false
			},
			requireScreenshot: {
				type: Boolean,
				default: false
			},
			rows: {
				type: Number,
				default: 10
			},
			payload: {
				type: Object,
				default: null
			},
		},

		data() {
			const self = this;

			return {
				valid: true,
				subject_rules: [
					v => !!v || 'Subject is required',
					v => (v && v.length <= 80) || "Subject can't be more than 80 characters"
				],
				email_rules: [
                    v => !!v || 'Email is required',
                    v => {
                		const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                		return pattern.test(v) || 'Invalid email address'
            		}
				],
				full_name_rules: [
                    v => !!v || 'Full name is required'
				],
				content_rules: [
					v => !!v || 'Email body is required',
					v => (v && (!self.mustEdit || v !== self.initial_content)) || "Please describe your problem"
				],
				subj: null,
				content: null,
				initial_content: null,
				attachment: null,
				attachment_error: null,
                email_from : null,
                full_name : null
			}
		},

		methods: {
			send() {
				if (!this.$refs.form.validate()) return;

				if (this.requireScreenshot && this.attachment == null) {
					this.attachment_error = 'Screenshot is required';
					return;
				}

				if (!this.ajax) {
					this.$refs.form.$el.submit();
				}
			},

			onAttach(f) {
				if (f.target.files.length) {
					this.attachment = f.target.files[0].name;
					this.attachment_error = null;
				}
			},
		},

		mounted() {
			this.subj = this.subject;
			this.content = this.body;
			this.initial_content = this.body;
		},

		watch: {
			'subject': function (v) {
				this.subj = this.subject;
			},
			'body': function (v) {
				this.initial_content = this.body;
				this.content = this.body;
			},
		},
		computed: {
			input_background_color() {
				return this.is_mobile ? '' : '#fff';
			}
		},
	}
</script>

<style scoped lang="less">
	.h-email-form {
		margin-top: 20px;
	}

	.h-attach-error {
		font-size: 12px;
		margin-left: 10px;
	}

	.button-info {
		color: #6e6e6e;
	}

	@media screen and (min-width : 320px) and (max-width : 480px) {
		.h-email-form {
			margin-top: 40px;
		}
		#cw-body .h-email-caption {
			margin: 0 0 35px;
			text-align: center;
			font-family: Roboto,sans-serif;
			color: #000;
		}
	}
</style>